module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starFull-45b994bd54b8b30e2d1478081fe6170e.svg";